module.exports = __webpack_public_path__ + "static/art1-71c20f855f06b67ec9b3030c459898f0.png";